export default __webpack_public_path__ + "static/media/SR_Gabiel.c854af7b.png";